import React from 'react';
import { CircularProgress } from '../CircularProgress';

interface CalorieRingProps {
  consumed: number;
  burned: number;
  goal: number;
}

export function CalorieRing({ consumed, burned, goal }: CalorieRingProps) {
  const netCalories = consumed - burned;
  const progress = (netCalories / goal) * 100;

  return (
    <div className="relative w-48 h-48 mx-auto">
      <CircularProgress
        value={progress}
        maxValue={100}
        size={192}
        strokeWidth={16}
        color="primary"
        label="Calories"
        animated
        centerContent={
          <div className="text-center">
            <div className="text-3xl font-bold">{netCalories}</div>
            <div className="text-xs text-muted-foreground">remaining</div>
          </div>
        }
      />
      
      <div className="mt-4 grid grid-cols-3 text-center text-sm">
        <div>
          <div className="font-medium text-blue-500">{consumed}</div>
          <div className="text-xs text-muted-foreground">Consumed</div>
        </div>
        <div>
          <div className="font-medium text-orange-500">{burned}</div>
          <div className="text-xs text-muted-foreground">Burned</div>
        </div>
        <div>
          <div className="font-medium text-red-500">{goal}</div>
          <div className="text-xs text-muted-foreground">Goal</div>
        </div>
      </div>
    </div>
  );
}